import Furniture from './Furniture';

import { TIME_NIGHT } from 'app/constants/AppConstants';

export default class Campfire extends Furniture {
  constructor({ game, location, data }) {
    super({ game, location, data });

    this.isLit = false;
    this.bb = new Phaser.Rectangle();
    this.cookArea = new Phaser.Rectangle(
      this.x + this.data.cook_area.x,
      this.y + this.data.cook_area.y,
      this.data.cook_area.w,
      this.data.cook_area.h
    );

    this.fire = this.asset.skeleton.findBone('fire');

    //
    // 2_lit, 3_extinguish, 4_extinguished
    this.asset.setMixByName('2_lit', '3_extinguish', 0.2);
    this.asset.setMixByName('3_extinguish', '2_lit', 0.2);
    this.asset.setMixByName('4_extinguished', '2_lit', 0.2);
    this.setAnim('4_extinguished');

    //
    this.sticksAnim = this.asset.setAnimationByName(1, 'sticks', false);
    this.sticksAnim.timeScale = 0;
    this.fuel = this.data.fuel || 1;
    this.timeToSave = 1;
    this.setSticks();
    // this.sticksAnim.trackTime = 11;

    //
    if (data.state === 'on') {
      this.lightUp();
    }
  }

  get height() {
    return 100;
  }

  updateTint(tween, value, tweenData) {
    super.updateTint(tween, value, tweenData);
  }

  updateBounds() {
    this.bb.x = this.worldPosition.x + this.data.bounding_box.x;
    this.bb.y = this.worldPosition.y + this.data.bounding_box.y;
    this.bb.width = this.data.bounding_box.w;
    this.bb.height = this.data.bounding_box.h;
  }

  handleInputDown() {
    this.location.state.interacted(this);

    if (!this.isLit) this.lightUp();
  }

  handleBucketDown() {
    if (this.isLit) this.extinguish();
  }

  lightUp() {
    if (!this.isLit) {
      this.isLit = true;
      this.setAnim('2_lit');

      this.game.sounds.playSFX('item_lightfire', { spriteID: 'sfx' });
      this.ambience = this.game.sounds
        .playSFX('ambience_fire', {
          spriteID: 'sfx',
          loop: true,
        })
        .get('ambience_fire');

      //
      this.onChange.dispatch();
    }
  }

  extinguish() {
    if (this.isLit) {
      this.isLit = false;
      this.setAnim('3_extinguish', false);

      if (this.location.time === TIME_NIGHT) {
        this.setNight();
      }

      this.ambience = null;
      this.game.sounds.stopAudioSprite('ambience_fire', { spriteID: 'sfx' });
      this.game.sounds.playSFX('item_extinguish', { spriteID: 'sfx' });

      //
      this.onChange.dispatch();
    }
  }

  canAddFuel(item) {
    const dx = this.x - item.x;
    const dy = this.y - 20 - item.y;
    if (Math.abs(dx) < 40 && Math.abs(dy) < 40) {
      return true;
    }
    return false;
  }

  addFuel() {
    this.fuel = 1;
    this.setSticks();
    this.onChange.dispatch();
  }

  destroy() {
    super.destroy();
  }

  step(dt) {
    super.step(dt);

    // fuel
    if (this.isLit) {
      if (this.fuel > 0) {
        this.fuel -= dt / 15;
        this.fuel = Math.max(0, this.fuel);
      }

      this.setSticks();

      this.fire.scaleY = 0.15 + 0.15 * this.fuel;

      //
      this.timeToSave -= dt;
      if (this.timeToSave <= 0 && this.fuel > 0) {
        this.timeToSave = 1;
        this.onChange.dispatch();
      }
    }

    // sound volume
    if (this.ambience) {
      const left = -this.location.x;
      const right = left + this.game.width;
      const width = (right - left) * 0.5;
      const mid = (right + left) * 0.5;
      if (this.x < right && this.x > left) {
        this.ambience.volume = 1 - Math.abs(this.x - mid) / width;
      } else {
        this.ambience.volume = 0;
      }
    }
  }

  setSticks() {
    this.sticksAnim.trackTime = 12 * (1 - this.fuel);
  }

  getLight() {
    const x = this.worldPosition.x;
    const y = this.worldPosition.y - 30;
    const power = this.isLit ? 0.5 + 0.5 * this.fuel : 0;
    return { x, y, power, w: 200, h: 100 };
  }

  //
  serialize() {
    const data = super.serialize();
    data.state = this.isLit ? 'on' : 'off';
    data.fuel = this.fuel;
    return data;
  }
}
